import { ComponentType } from 'react';
import { IconTextField, IconTitle } from '@bynder/icons';
import { SearchOptionType, SelectedSearchOption } from '../helpers/types';

export const SEARCH_AND_OPERATOR_FEATURE_ID = '58bffb2e-5254-004a-31ec-51ee1fed861f';

// UI and parsing data per search option. `parseFromQuery` constructs the
// variant — called only on definitions whose `queryField` was found in the query.
// The Solr clause itself is built by `SEARCH_OPTION_CLAUSE_BUILDERS` in
// `helpers/statelessFiltersFromSessionStorage.ts`, shared with the applied terms.
export type SearchOptionDefinition = {
	key: SearchOptionType;
	queryField: string;
	parseFromQuery: (query: string) => SelectedSearchOption;
	Icon: ComponentType;
	translationKey: string;
};

export const SEARCH_OPTION_DEFINITIONS: Record<SearchOptionType, SearchOptionDefinition> = {
	[SearchOptionType.Title]: {
		key: SearchOptionType.Title,
		queryField: 'name_ci:',
		parseFromQuery: () => ({ key: SearchOptionType.Title }),
		Icon: IconTitle,
		translationKey: 'spotlight.searchOptions.chips.title',
	},
	[SearchOptionType.Description]: {
		key: SearchOptionType.Description,
		queryField: 'description:',
		parseFromQuery: () => ({ key: SearchOptionType.Description }),
		Icon: IconTextField,
		translationKey: 'spotlight.searchOptions.chips.description',
	},
};

// Toggle chips in the Spotlight modal ("Title" and "Description" for now).
export const CHIP_TOGGLE_OPTIONS: SearchOptionDefinition[] = [
	SEARCH_OPTION_DEFINITIONS[SearchOptionType.Title],
	SEARCH_OPTION_DEFINITIONS[SearchOptionType.Description],
];
